//url地址
// export const URL = 'http://localhost:8080';
// export const URL = 'http://10.205.14.47:8002/dorm_cqu'; //赵流川地址-重大-测试
// export const URL = ''; //测试地址
export const URL = 'http://huxiface.cqu.edu.cn:8080/dorm'; //重大正式环境


// export const addressUrl = '/dorm_cqu'; //地址后缀
export const addressUrl = '/dorm'; //地址后缀

export const ServiceUrl = 'http://huxiface.cqu.edu.cn:8080/aiface/index.html'; //ServiceUrl
export const AuthenticationURL = 'https://sso.cqu.edu.cn/login?service=' + ServiceUrl; //统一认证地址
export const logoutURL = 'https://sso.cqu.edu.cn/logout?service=/authserver/login'; //注销地址
// export const AuthenticationURL = 'http://authserver.cqu.edu.cn/authserver/login?service=' + ServiceUrl; //统一认证地址old
// export const logoutURL = 'http://authserver.cqu.edu.cn/authserver/logout?service=/authserver/login'; //注销地址old

//公共
export const COM_NAV_STATUS = 'COM_NAV_STATUS'
export const COM_HEADER_STATUS = 'COM_HEADER_STATUS'
export const COM_LOADING_STATUS = 'COM_LOADING_STATUS'

export const COM_SHOW_TOAST = 'COM_SHOW_TOAST'              //显示toast
export const COM_SHOW_SUCCESS = 'COM_SHOW_SUCCESS'          //显示成功toast
export const COM_SHOW_FAIL = 'COM_SHOW_FAIL'                //显示失败toast
export const COM_TOAST_MSG = 'COM_TOAST_MSG'                //显示toast文字
export const COM_SHOW_ALERT = 'COM_SHOW_ALERT'
export const COM_ALERT_MSG = 'COM_ALERT_MSG'
export const COM_SHOW_TIME_PICKER = 'COM_SHOW_TIME_PICKER'  //显示timepicker

//user 用户
export const SET_USER_INFO = 'SETUSERINFO'      //设置用户信息
export const SET_LOGIN_STATUS = 'SET_LOGIN_STATUS' //设置登录状态
export const GET_USER_DATA = 'GET_USER_DATA'    //获取用户数据信息

//sports 主题详情
export const GET_SPORTS_DETAIL = 'GET_SPORTS_DETAIL' //获取主题详情

//travels 主题详情
export const GET_TRAVELS_DETAIL = 'GET_TRAVELS_DETAIL' //获取主题详情


// WEBPACK FOOTER //
// ./src/vuex/types.js